export default {
  namespaced: true,
  pacom: {
    pacom: "pacom",
    masterAccounts: "master accounts",
    masterAccount: "master account",
    first_name: "first name",
    last_name: "last name",
    link: "link",
    username: "username",
    token: "token",
    password: "password",
    token_expired: "token expiration",
    email: "email",
    sites: "sites",
    site: "site",
    name: "nombre",
    description: "description",
    address: "address",
    latitude: "latitude",
    longitude: "longitude",
    timeZone: "timezone",
    profile: "profile",
    calendar: "calendar",
    serialNumber: "serial number",
    actions: "actions",
    schemaTypes: "schema types",
    schema_type: "schema type",
    display_name: "display name",
    id: "id",
    devices: "devices",
    gateway_id: "gateway id",
    schema_actions: "schema actions",
    typeAlarm: "alarm type",
    typeAlarms: "alarm types",
    priority: "priority",
    dispatchAlarm: "dispatchAlarm",
    alarms: "alarms",
    state: "state",
    creation_time: "creation time",
    units: "units",
    center: "center",
    sector: "sector",
    device: "device",
    schemaEvent: "event type",
    time: "time",
    type: "type",
    logs: "logs",
    resources: "resources",
    idAlarm: "id alarm",
    color: "color",
     status: "status"
  }
}
